import { Observable, pluck } from 'rxjs'
import { Injectable } from '@angular/core'
import { Auth } from '@angular/fire/auth'
import { collection, collectionData, doc, docData, DocumentReference, Firestore, limit, orderBy, query, setDoc } from '@angular/fire/firestore'

import { FreshMLArchive, MLArchive } from '@innersight-os/shared/firestore-interfaces'
import { serverTimestamp } from '@angular/fire/firestore'
import { DocumentData } from '@firebase/firestore-types'


@Injectable({
  providedIn: 'root'
})
export class MLArchivesService {
  constructor(
    private auth: Auth,
    private db: Firestore,
  ) {}

  getLatestMLArchive = (): Observable<MLArchive> =>
    collectionData(
      query<MLArchive, DocumentData>(
        // eslint-able-next-line @typescript-eslint/no-explicit-any
        collection(this.db, 'mlArchives') as any,
        orderBy('createdAt', 'desc'),
        limit(1),
      )
    ).pipe(pluck(0)) as Observable<MLArchive>

  getSegmentationMLArchive = (segmentationId: string): Observable<MLArchive> =>
    docData<MLArchive>(doc(this.db, 'mlArchives', segmentationId) as DocumentReference<MLArchive>)

  async create(folderId: string, dbType: string, rawFilename: string, sumFilename: string, volumePath: string, segmentationPath: string, operationId: string, uploadId: string, volumeId: string, segmentationId: string) {
    const mlArchive: FreshMLArchive = {
      folderId,
      dbType,
      rawFilename,
      sumFilename,
      volumePath,
      segmentationPath,
      ...this.createdFields(),
      operationId,
      uploadId,
      volumeId,
      segmentationId,
    }
    return setDoc(
      doc(this.db, 'mlArchives', segmentationId),
      mlArchive,
    )
  }

  private createdFields = () => ({
    createdAt: serverTimestamp(),
    createdBy: this.auth.currentUser.uid,
  })
}
